import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface StyledProps {
  noPadding?: boolean;
}

export const Container = styled.section`
  display: block;
`;

export const LetterTab = styled.span`
  display: inline-flex;
  align-items: center;
  background-color: rgba(${ColorPalette.RGB.BrightGray}, 0.5);
  color: ${ColorPalette.HEX.DimGray};
  width: 100%;
  height: 40px;
  padding: 0 24px;
  line-height: 1.4px;
`;

export const Day = styled.span`
  padding: 16px 16px 0 16px;
  margin-bottom: 16px;
  font-size: 12px;
  color: ${({ theme }) => theme.expensesSelectableList.day};
`;

export const List = styled.ol.attrs<any, StyledProps>((): any => ({}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;

  @media ${({ theme }) => theme.device.mobile} {
    ${({ noPadding }) => !noPadding && 'padding: 0 16px;'}
    &:last-child {
      margin-bottom: 100px;
    }
  }
`;
